
import { FileText, MessageCircle, Shield } from "lucide-react";
import { DashboardCard } from "./DashboardCard";

interface DashboardMetricsProps {
  activeRequestsCount: number;
  successRate?: number;
  totalRefunded?: number;
}

export function DashboardMetrics({ 
  activeRequestsCount, 
  successRate = 0, 
  totalRefunded = 0 
}: DashboardMetricsProps) {
  return (
    <div className="grid gap-6 md:grid-cols-3 animate-fade-in">
      <DashboardCard 
        icon={<MessageCircle className="h-8 w-8 text-blue-500" />}
        title="Active Requests"
        description="Refund requests currently in progress"
        value={activeRequestsCount.toString()}
        bgClass="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200"
      />
      <DashboardCard 
        icon={<Shield className="h-8 w-8 text-green-500" />}
        title="Success Rate"
        description="Percentage of successful refunds"
        value={`${successRate}%`}
        bgClass="bg-gradient-to-br from-green-50 to-green-100 border-green-200"
      />
      <DashboardCard 
        icon={<FileText className="h-8 w-8 text-purple-500" />}
        title="Total Refunded"
        description="Total amount refunded to date"
        value={`$${totalRefunded.toFixed(2)}`}
        bgClass="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200"
      />
    </div>
  );
}
